import styled from 'styled-components'
import Paragraph from '..'

export const ParagraphWithEllipsis = styled(Paragraph)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
